{
  "appointment-history-page": {
    "text": {
      "in-the-past": "In der Vergangenheit oder Abgesagt",
      "no-appointment": "Sie haben keinen Termin gebucht!",
      "upcoming": "Bevorstehender Termin"
    },
    "meta": {
      "title": "Termine",
      "description": "Liste der gebuchten Termine"
    }
  }
}
